import { useMutation, useQuery } from '@apollo/client/react/hooks';
import { useContext, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useFetch } from '../../services/NetworkService';
import { useHostName } from '../../services/hostName';
import { ChildrenOnly } from '../../types/ChildrenOnly';
import { env } from '../../util/env';
import { makeApolloClient, makeGqlContext } from '../shared';

export const MegatronContext = makeGqlContext();

export const useMegatronMutation: typeof useMutation = (document, options?) =>
  useMutation(document, { ...options, client: useContext(MegatronContext) });

export const useMegatronQuery: typeof useQuery = (document, options?) =>
  useQuery(document, { ...options, client: useContext(MegatronContext) });

export const MegatronProvider = ({ children }: ChildrenOnly) => {
  const fetch = useFetch();
  const hostName = useHostName();
  const { whiteLabelProps } = useTheme();

  const url = whiteLabelProps?.baseRoute
    ? `https://${hostName}/graphql/public`
    : env.MEGATRON_PUBLIC_GRAPHQL_HOST;

  const client = useMemo(() => makeApolloClient(fetch, url), [fetch, url]);

  return <MegatronContext.Provider value={client}>{children}</MegatronContext.Provider>;
};
